

export const ACC_FILES = [
  "acc_results/251028_205326_R.json",
  "acc_results/251028_201805_Q.json",
  "acc_results/251028_200124_FP.json",
  "acc_results/251125_205255_R.json",
  "acc_results/251125_201813_Q.json",
  "acc_results/251125_200200_FP.json",
  "acc_results/260106_201709_R.json",
  "acc_results/260106_201709_Q.json",
  "acc_results/260106_200144_FP.json",
  "acc_results/260120_205334_R.json",
  "acc_results/260120_201832_Q.json",
  "acc_results/260120_200146_FP.json",
  "acc_results/260203_205337_R.json",
  "acc_results/260203_201827_Q.json",
  "acc_results/260203_200214_FP.json",
  "acc_results/260217_205103_R.json",
  "acc_results/260217_201623_Q.json",
  "acc_results/260217_200003_FP.json",
  "acc_results/260303_205514_R.json",
  "acc_results/260303_202106_Q.json",
  "acc_results/260303_200403_FP.json",
  "acc_results/260317_205233_R.json",
  "acc_results/260317_201748_Q.json",
  "acc_results/260317_200050_FP.json",
  "acc_results/260331_205207_R.json",
  "acc_results/260331_201700_Q.json",
  "acc_results/260331_195957_FP.json",
  "acc_results/260414_205232_R.json",
  "acc_results/260414_201745_Q.json",
  "acc_results/260414_200202_FP.json",
  "acc_results/260505_205254_R.json",
  "acc_results/260505_201742_Q.json",
  "acc_results/260505_200130_FP.json",
  "acc_results/260519_205309_R.json",
  "acc_results/260519_201749_Q.json",
  "acc_results/260519_200129_FP.json",
  "acc_results/260602_205229_R.json",
  "acc_results/260602_201707_Q.json",
  "acc_results/260602_200026_FP.json",
  "acc_results/260616_205626_R.json",
  "acc_results/260616_202050_Q.json",
  "acc_results/260616_200350_FP.json",
  "acc_results/260630_210222_R.json",
  "acc_results/260630_202823_FP.json",
  "acc_results/260714_205328_R.json",
  "acc_results/260714_201927_Q.json",
  "acc_results/260714_200322_FP.json",
  "acc_results/260728_205408_R.json",
  "acc_results/260728_201823_Q.json",
  "acc_results/260728_200232_FP.json",
  "acc_results/260811_205500_R.json",
  "acc_results/260811_201926_Q.json",
  "acc_results/260811_200250_FP.json",
  "acc_results/260825_205141_R.json",
  "acc_results/260825_201710_Q.json",
  "acc_results/260825_200015_FP.json",
  "acc_results/260908_205232_R.json",
  "acc_results/260908_201742_Q.json",
  "acc_results/260908_200139_FP.json",
  "acc_results/260922_205327_R.json",
  "acc_results/260922_201829_Q.json",
  "acc_results/260922_200147_FP.json",
  "acc_results/261006_205232_R.json",
  "acc_results/261006_201847_Q.json",
  "acc_results/261006_200241_FP.json",
  "acc_results/261020_205232_R.json",
  "acc_results/261103_205321_R.json",
  "acc_results/261103_201836_Q.json",
  "acc_results/261103_200234_FP.json"
];
export const AC_FILES = [
  "ac_results/2025_11_11_20_45_RACE.json",
  "ac_results/2025_11_11_20_11_QUALIFY.json",
  "ac_results/2025_11_11_19_56_PRACTICE.json",
  "ac_results/2025_12_9_20_2_PRACTICE.json",
  "ac_results/2025_12_9_20_18_QUALIFY.json",
  "ac_results/2025_12_9_20_51_RACE.json",
];
export const AC_EVO_FILES = [
  "ace_results/Resultsresults_20260818_193355_race.json",
  "ace_results/results_20260901_181857_qualify.json",
  "ace_results/results_20260901_180329_practice.json",
  "ace_results/results_20260901_185605_race.json",
  "ace_results/results_20260929_180603_practice.json",
  "ace_results/results_20260929_182126_qualify.json",
  "ace_results/results_20260929_185450_race.json",
  "ace_results/results_20261013_181324_practice.json",
  "ace_results/results_20261013_182849_qualify.json",
  "ace_results/results_20261013_190531_race.json",
  "ace_results/results_20261027_180540_practice.json",
  "ace_results/results_20261027_182110_qualify.json",
  "ace_results/results_20261027_185709_race.json",
];